import { Location } from 'history';

import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { isMarketplacePage } from '@reverbdotcom/commons/src/url_helpers';
import { COUNTRY_CODES, SHIPPING_REGION_CODES } from '../../shared/constants';

const CONTROL_GROUP = 0;
const EXPERIMENT_GROUP = 1;

export function shouldApplyLikelihoodToSellBoosts(user: Partial<IUser>) {
  return user.countryCode === COUNTRY_CODES.US;
}

export function ecsBoostExperimentGroup(user: Partial<IUser>, location: Partial<Location>) {
  if (isMarketplacePage(location) && user.shippingRegionCode == SHIPPING_REGION_CODES.US_CON) {
    return EXPERIMENT_GROUP;
  }

  return CONTROL_GROUP;
}
